// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:34:27

export default {
  "id": "lady-pool",
  "slug": "lady-pool",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/60e9d5d6300b41778dfdfd4ec86d32cb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/60e9d5d6300b41778dfdfd4ec86d32cb/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Lady Pool",
      "description": "We are glad to welcome you to the bright world of a humorous dress-up game where fashion collides with the comic book universe! Get ready for a creative reinterpretation of your favorite comic book anti-hero costumes: bold color combinations, unexpected prints and fun accessories are available to you. There is everything here: from funny hats that emphasize individuality to stylish superhero jumpsuits. Unleash your imagination!",
      "instructions": "Let's mentally jump into the comic book universe to create a vibrant and unusual female version of our favorite anti-hero. Successful images can be saved as PNG images. Depending on the gaming device, a computer mouse click or a simple touch on touch screens is used to control it.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "anime",
        "dress",
        "fantasy",
        "girls",
        "superhero"
      ]
    },
    "zh-CN": {
      "title": "女神泳池",
      "description": "我们很高兴欢迎您来到一个充满幽默的换装游戏明亮世界，在这里时尚与漫画宇宙碰撞！准备好对您最喜欢的漫画反英雄服装进行创意重释吧：大胆的色彩搭配、意想不到的图案和有趣的配饰供您选择。这里应有尽有：从强调个性的搞笑帽子到时尚的超人连体服。释放您的想象力！",
      "instructions": "让我们在心中跳入漫画书宇宙，创造一个充满活力且独特的女性版我们最喜欢的反英雄。成功的图像可以保存为PNG格式。根据游戏设备的不同，使用电脑鼠标点击或触摸屏简单触摸来控制它。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "动漫",
        "服饰",
        "幻想",
        "少女",
        "超级英雄"
      ]
    },
    "zh-TW": {
      "title": "女士泳池",
      "description": "我們很高興歡迎您進入一個充滿幽默的換裝遊戲輝煌世界，這裡時尚與漫畫宇宙碰撞！準備好對您最喜愛的漫畫反英雄裝扮進行創意重解讀：鮮豔的色彩組合、意想不到的花紋和有趣的配飾任您挑選。這裡应有盡有：從強調個性的搞笑帽子到時尚的超級英雄連身衣。釋放您的想像力！",
      "instructions": "讓我們心靈跳入漫畫宇宙，創造我們最喜愛的反英雄的生動且獨特的女性版本。成功的圖像可以儲存為PNG圖片。根據遊戲設備，使用電腦滑鼠點擊或觸控屏幕的簡單觸碰來控制它。",
      "genres": [
        "裝扮"
      ],
      "tags": [
        "動漫",
        "服裝",
        "奇幻",
        "女孩",
        "超級英雄"
      ]
    },
    "zh-HK": {
      "title": "貴婦泳池",
      "description": "我們高興地歡迎你來到一個幽默換裝遊戲的明亮世界，這裡時尚與漫畫宇宙相碰撞！準備好對你們最愛的漫畫反英雄裝扮進行創意的重新解讀：鮮豔的色彩組合、意外的圖案和有趣的配飾等你來選。這裡有什麼都有：從強調個性的搞笑帽子到時尚的超人連身裝。釋放你的想像力吧！",
      "instructions": "讓我們心理上跳進漫畫書宇宙，創造一個生動而獨特的女性版本我們最喜愛的反英雄。成功的圖像可以儲存為PNG圖像。根據遊戲設備，使用電腦滑鼠點擊或觸控螢幕的簡單觸碰來控制它。",
      "genres": [
        "打扮"
      ],
      "tags": [
        "動漫",
        "服裝",
        "奇幻",
        "女孩",
        "超級英雄"
      ]
    },
    "ja": {
      "title": "レディ・プール",
      "description": "お待ちしております！面白いコスチュームゲームの明るい世界へようこそ、ファッションとコミックのユニバースが衝突する場所です！お気に入りのコミックのアンチヒーローのコスチュームをクリエイティブに再解釈する準備をしてください：大胆な色の組み合わせ、予想外の柄、楽しいアクセサリーがあなたのために用意されています。ここには何でもあります：個性を強調するユニークな帽子から、スタイリッシュなスーパーヒーローのジャンプスーツまで。あなたの想像力を解き放ちましょう！",
      "instructions": "心で漫画のユニバースに飛び込み、私たちの好きなアンチヒーローの生き生きとしたユニークな女性バージョンを作りましょう。成功した画像はPNG画像として保存できます。ゲーム機によっては、コンピューターモウスのクリックまたはタッチスクリーンの単純なタッチで操作されます。",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "アニメ",
        "ドレス",
        "ファンタジー",
        "少女",
        "スーパーヒーロー"
      ]
    },
    "ko": {
      "title": "라디 Πools",
      "description": "우리는 흥미로운 드레스업 게임의 밝은 세상을 맞이하게 되어 기쁩니다: 패션과 코믹북 우주가 충돌하는 세상입니다! 여러분의 아이돌 코믹북 애니히어로 의상을 창의적으로 재해석한 준비를 해주세요: 눈에 띄는 색상 조합, 예상치 못한 패턴과 재미있는 액세서리가 여러분을 기다립니다. 여기서는 모든 것이 있습니다: 개성을 강조하는 웃는帽子부터 스타일리시한 슈퍼히어로 정장까지. 여러분의 상상력을 발휘해보세요!",
      "instructions": "뇌리로만 생각하면서 만화책 우주로 뛰어들어 우리가 좋아하는 반대영웅의 생동감 넘치고 독특한 여성 버전을 만들어 보세요. 성공적인 이미지는 PNG 이미지로 저장할 수 있습니다. 게임 장치에 따라 컴퓨터 마우스 클릭이나 터치 스크린의 간단한 터치로 제어됩니다.",
      "genres": [
        "드레스업"
      ],
      "tags": [
        "애니메이션",
        "드레스",
        "판타지",
        "소녀",
        "슈퍼히어로"
      ]
    },
    "fr": {
      "title": "Dame Piscine",
      "description": "Nous avons le plaisir de vous accueillir dans le monde lumineux d'un jeu de déguisement humoristique où la mode se heurte à l'univers des bandes dessinées ! Préparez-vous à une interprétation créative de vos costumes d'antihéros préférés : des combinaisons de couleurs audacieuses, des motifs inattendus et des accessoires amusants sont à votre disposition. Tout y est : des chapeaux humoristiques qui mettent en avant l'individualité aux combinaisons de superhéros stylées. Libérez votre imagination !",
      "instructions": "Plongeons mentalement dans l'univers des bandes dessinées pour créer une version féminine vibrante et inhabituelle de notre anti-héros préféré. Les images réussies peuvent être enregistrées sous forme d'images PNG. Selon le périphérique de jeu, un clic de souris sur un ordinateur ou un simple toucher sur les écrans tactiles est utilisé pour le contrôler.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "anime",
        "vêtements",
        "fantasy",
        "filles",
        "super-héros"
      ]
    }
  }
};
